export default __webpack_public_path__ + "static/media/arrowNext.c06426a9.svg";